import { Modal, Container, PureRow, H, Button } from "components";
import { setData } from "domain/store/static";
import React from "react";
import { useTranslation } from "react-i18next";

export const useConfirmationModal = ({
  onAccept,
  onCancel,
}: {
  onAccept: (data?: any) => void;
  onCancel?: () => void;
}) => {

  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState<any>();  // Data passed to onAccept
  const { t } = useTranslation('indicators');
  const openModal = (data?: any) => {
    setData(data);
    setOpen(true);
  }
  const doClose = () => setOpen(false);

  const element = (
    <Modal
      show={open}
      onClose={doClose}
      dismissable
      className='indicator-description-modal'
    >
      <Container className='indicator-modal-body'>
        <PureRow md='1' className='title-container'>
          <H.H4 className='title'>
            {t(`common:are-you-sure`)}
          </H.H4>
          {/* Accept/Cancel buttons */}
          <Container className='indicator-modal-buttons'>
            <PureRow md='1' className='indicator-row'>
              <Button
                className='indicator-modal-button danger'
                onClick={() => { doClose(); onAccept(data); }}
              >
                {t(`common:actions.accept`)}
              </Button>
              &nbsp;
              <Button
                className='indicator-modal-button'
                onClick={() => { doClose(); (onCancel && onCancel()); }}
              >
                {t(`common:actions.back`)}
              </Button>
            </PureRow>
          </Container>
        </PureRow>
      </Container>
    </Modal>
  );

  return {
    element,
    openModal,
  }
};